import { FieldType } from '../../types/Field.type';
export const ContractEntityRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.contract_entity.label',
    fallbackLabel: 'Contractual entity',
    type: FieldType.Enum,
    options: [
        { key: 'KLARNA_AB', label: 'fields.enm.contract_entity.options.KLARNA_AB', fallbackLabel: 'Klarna Bank AB' },
        { key: 'KLARNA_AU', label: 'fields.enm.contract_entity.options.KLARNA_AU', fallbackLabel: 'Klarna Australia Pty Ltd' },
        { key: 'KLARNA_CA', label: 'fields.enm.contract_entity.options.KLARNA_CA', fallbackLabel: 'Klarna Canada Limited' },
        { key: 'KLARNA_INC', label: 'fields.enm.contract_entity.options.KLARNA_INC', fallbackLabel: 'Klarna Inc' },
        { key: 'KLARNA_NZ', label: 'fields.enm.contract_entity.options.KLARNA_NZ', fallbackLabel: 'Klarna NZ Limited' },
        { key: 'KLARNA_DEB', label: 'fields.enm.contract_entity.options.KLARNA_DEB', fallbackLabel: 'Klarna Bank AB, German Branch' },
        { key: 'KLARNA_UKB', label: 'fields.enm.contract_entity.options.KLARNA_UKB', fallbackLabel: 'Klarna Bank AB, UK Branch' },
        { key: 'KLARNA_FRB', label: 'fields.enm.contract_entity.options.KLARNA_FRB', fallbackLabel: 'Klarna Bank AB, French Branch' },
        { key: 'KLARNA_MX', label: 'fields.enm.contract_entity.options.KLARNA_MX', fallbackLabel: 'Klarna Mexico' },
    ],
    trackFieldValueWithAnalytics: false,
};
